export enum PatientPhysicianAssociationEnum {
  Referring = 1,
  Primary = 2,
  Following = 3,
  Consulting = 4
}

export const PatientPhysicianAssociationOptions = [
{ id: 1, label: 'Referring' },
{ id: 2, label: 'Primary' },
{ id: 3, label: 'Following' },
{ id: 4, label: 'Consulting' }
];
